var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { inject, observer } from "mobx-react";
import React from "react";
import WelcomeStepView from "./welcome-step-view";
import WorkflowStepView from "./workflow-step-view";
import "./workflow-wizard.scss";
import FinalStepView from "./final-step-view";
var WorkflowWizard = /** @class */ (function (_super) {
    __extends(WorkflowWizard, _super);
    function WorkflowWizard(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            stepIndex: -1
        };
        return _this;
    }
    Object.defineProperty(WorkflowWizard.prototype, "renderStep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b, _c, _d, _e;
            var steps = (_b = (_a = this.props.workflowStore) === null || _a === void 0 ? void 0 : _a.caseType) === null || _b === void 0 ? void 0 : _b.workflowSteps;
            if (!steps)
                return null;
            var stepIndex = this.state.stepIndex;
            if (stepIndex < 0 || stepIndex >= steps.length)
                return null;
            var step = steps[stepIndex];
            return (_jsx(WorkflowStepView, { step: step, index: stepIndex, totalSteps: steps.length, onStepComplete: function () { return _this.onStepComplete(); }, takePhoto: (_c = this.props.workflowStore) === null || _c === void 0 ? void 0 : _c.takePhoto, acceptPhoto: (_d = this.props.workflowStore) === null || _d === void 0 ? void 0 : _d.acceptPhoto, rejectPhoto: (_e = this.props.workflowStore) === null || _e === void 0 ? void 0 : _e.rejectPhoto }, void 0));
        }
    });
    Object.defineProperty(WorkflowWizard.prototype, "onStepComplete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b, _c, _d;
            var steps = (_b = (_a = this.props.workflowStore) === null || _a === void 0 ? void 0 : _a.caseType) === null || _b === void 0 ? void 0 : _b.workflowSteps;
            if (!steps)
                return null;
            var stepIndex = this.state.stepIndex + 1;
            this.setState(__assign(__assign({}, this.state), { stepIndex: stepIndex }));
            if (stepIndex >= steps.length)
                (_d = (_c = this.props.workflowStore) === null || _c === void 0 ? void 0 : _c.finish) === null || _d === void 0 ? void 0 : _d.call(_c);
        }
    });
    Object.defineProperty(WorkflowWizard.prototype, "onStartClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b, _c, _d;
            var stepsCount = (_d = (_c = (_b = (_a = this.props.workflowStore) === null || _a === void 0 ? void 0 : _a.caseType) === null || _b === void 0 ? void 0 : _b.workflowSteps) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
            if (stepsCount > 0)
                this.setState(__assign(__assign({}, this.state), { stepIndex: 0 }));
        }
    });
    Object.defineProperty(WorkflowWizard.prototype, "renderWelcomeStep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsx(WelcomeStepView, { onStart: function () { return _this.onStartClick(); } }, void 0));
        }
    });
    Object.defineProperty(WorkflowWizard.prototype, "renderFinalStep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return (_jsx(FinalStepView, {}, void 0));
        }
    });
    Object.defineProperty(WorkflowWizard.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b;
            var steps = (_b = (_a = this.props.workflowStore) === null || _a === void 0 ? void 0 : _a.caseType) === null || _b === void 0 ? void 0 : _b.workflowSteps;
            if (!steps)
                return (_jsx("div", {}, void 0));
            var content;
            if (this.state.stepIndex >= 0 && this.state.stepIndex < steps.length) {
                content = this.renderStep();
            }
            else if (this.state.stepIndex < 0) {
                content = this.renderWelcomeStep();
            }
            else {
                content = this.renderFinalStep();
            }
            return (_jsx("div", __assign({ className: "workflow-wizard" }, { children: content }), void 0));
        }
    });
    WorkflowWizard = __decorate([
        inject('workflowStore'),
        inject('languageStore'),
        observer
    ], WorkflowWizard);
    return WorkflowWizard;
}(React.Component));
export default WorkflowWizard;
